import { Button, Text } from "@chakra-ui/react";
import React from "react";

import { downloadFile } from "@nens/shared-utils";

export const ExplainReportFile: React.FC = () => {
  return (
    <>
      <Text pb="5">
        Gebruik deze optie om een GPD-rapport aan te leveren. De waarden uit het bestand worden in
        een bewerkbare tabel geladen. Zorg ervoor dat u het format in het volgende template
        hanteert.
      </Text>
      <Button
        mb={4}
        variant="primary"
        onClick={() =>
          downloadFile("/files/gpdReportExcelTemplate.xlsx", "gpdReportExcelTemplate.xlsx")
        }
      >
        Download Excel-template
      </Button>
    </>
  );
};
